import React, { useEffect, useState } from "react";
import { styled } from "styled-components";
import { getPublicUrl } from "../../../../helpers/helper_functions";
import { InfoImage } from "./SharedComponents";

import "./InfoBox.css";

const HealthImpactInfo = () => {

  return (
    <div className="info-box-wrapper left-box">
      <p className="info-text-title">Eating meat is not good for you</p>
      <div className="info-text-body">
        <p>
          {" "}
          A strong body of scientific evidence suggests that meat and dairy
          consumption is tied with heart disease, stroke, type 2 diabetes,
          obesity, kidney stones, certain cancers, acne, and even earlier death.
          These foods are a source of unhealthy fats and hormones in the
          American diet.
        </p>
        <p>
          Vegan diets have been correlated with many health benefits, including
          lower cholesterol levels, improved blood pressure, weight management,
          and a reduced risk of the aforementioned conditions.
        </p>
      </div>
    </div>
  );
};


const HealthImpactImage = () => {
  return (
    <InfoImage
      className="info-box-image"
      $background_image={getPublicUrl("assets/Home/insulinshot.jpg")}
      $background_image_details={"no-repeat 67% 30%"}
    ></InfoImage>
  );
};

export default {
  info: () => <HealthImpactInfo/>,
  image: () => <HealthImpactImage/>,
};

// source: https://clf.jhsph.edu/projects/technical-and-scientific-resource-meatless-monday/meatless-monday-resources/meatless-monday-resourcesmeat-consumption-trends-and-health-implications#:~:text=A%20strong%20body%20of%20scientific,15%2C16%20and%20earlier%20death.
// source: https://www.pcrm.org/good-nutrition/nutrition-information/health-concerns-about-dairy#:~:text=Milk%20and%20other%20dairy%20products,Cheese%20is%20especially%20dangerous.
// source: https://www.ncbi.nlm.nih.gov/pmc/articles/PMC7613518/#:~:text=Vegetarians%20and%20vegans%20typically%20have,as%20lower%20bone%20mineral%20density.
// source: https://www.pcrm.org/good-nutrition/nutrition-information/health-concerns-about-dairy#:~:text=Milk%20and%20other%20dairy%20products,Cheese%20is%20especially%20dangerous.
